/**
 * index.tsx - Application entry point
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initDevBridge } from './db/devBridge';

// Initialize DevBridge for Chrome DevTools Console interactivity
initDevBridge();

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline PWA support
serviceWorkerRegistration.register();

